import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExpandMoreRounded, Language } from '@mui/icons-material';
import { MenuItem, Select } from '@mui/material';

import { filterSupportedLanguages } from '../../i18n';

import { useLanguageContext } from '~providers';

const LANGUAGE_OPTIONS = [
  { value: 'en-US', labelKey: 'language.english' },
  { value: 'es-DO', labelKey: 'language.dominicanSpanish' },
  { value: 'es-MX', labelKey: 'language.mexicanSpanish' },
  { value: 'es-PA', labelKey: 'language.panamanianSpanish' },
  { value: 'es-CO', labelKey: 'language.colombianSpanish' },
  { value: 'de', labelKey: 'language.german' },
  { value: 'fr-FR', labelKey: 'language.french' },
  { value: 'sv-SE', labelKey: 'language.swedish' },
];

export const LanguageSelectV1: React.FC = () => {
  const { locale, selectLanguage } = useLanguageContext();
  const { t } = useTranslation();

  return (
    <Select
      startAdornment={<Language fontSize="small" sx={{ mr: 0.75 }} />}
      value={locale}
      onChange={(e) => selectLanguage(e.target.value)}
      size="small"
      sx={(theme) => ({
        ...theme.typography['Poppins/Subheading-sm'],
        borderRadius: '200px',
        paddingLeft: 2.5,
        '.MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
          paddingRight: 5,
        },
        color: '#374151',
        width: 'fit-content',
        '& svg.MuiSelect-icon': {
          marginRight: 0.5,
          color: '#9CA3AF',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          boxShadow: 'none !important',
        },
      })}
      IconComponent={ExpandMoreRounded}
    >
      {filterSupportedLanguages(LANGUAGE_OPTIONS).map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {t(option.labelKey)}
        </MenuItem>
      ))}
    </Select>
  );
};
